import HealthSafety from "../../../../src/components/health-safety";
import * as React from 'react';
export default {
  HealthSafety,
  React
};